
import { Component, Inject, OnInit } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { from } from 'rxjs';
import { User } from '../../services/user.service';
import { UserRole } from '../../shared/models/user.model';

@Component({
    selector: 'app-edit-user',
    imports: [
    MatOptionModule,
    MatSnackBarModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDialogModule
],
    templateUrl: './edit-user.component.html',
    styleUrl: './edit-user.component.scss'
})
export class EditUserComponent implements OnInit {
    userForm!: FormGroup;
    loading = false;
    roles = Object.values(UserRole);
    currentEmail!: string;
    userId!: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: User,
        private dialogRef: MatDialogRef<EditUserComponent>,
        private fb: FormBuilder,
        private fns: Functions,
        private snackBar: MatSnackBar
    ) {}

    public ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        this.userForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            role: ['', Validators.required],
            displayName: ['', Validators.required],
        });

        this.currentEmail = this.data.email;
        this.userId = this.data.id;
        this.userForm.patchValue(this.data);
    }

    updateUser() {
        if (this.userForm.invalid) return;

        this.loading = true;
        const { email, role, displayName } = this.userForm.value;

        const callable = httpsCallable(this.fns, 'editUser');
        from(callable({
            email,
            role,
            displayName,
            currentEmail: this.currentEmail,
            id: this.userId,
        })).subscribe({
            next: () => {
                this.dialogRef.close();
                this.snackBar.open('User updated successfully', 'Close', {
                    duration: 3000,
                });
            },
            error: (err) => {
                this.loading = false;
                this.snackBar.open('Error: ' + err.message, 'Close', {
                    duration: 3000,
                });
            },
            complete: () => {
                this.loading = false;
            },
        });
    }

    cancel(): void {}
}
